import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild  } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { TableModule, Table } from 'primeng/table';
import { finalize, forkJoin } from 'rxjs';
import { Messages } from '../../../common/constants/messages';
import { CompanyService } from '../../services/company.service';
import { HeaderService } from '../../services/header.service';
import { DatePickerModule } from 'primeng/datepicker';
import {  
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,  
  Validators
} from '@angular/forms';
import { ValidationPatterns } from '../../../common/constants/messages';
import { AbstractControl, ValidationErrors } from '@angular/forms';
@Component({
  selector: 'app-business-search',
  imports: [
    CommonModule, NgxSpinnerModule, TableModule, DialogModule, DatePickerModule, ReactiveFormsModule
  ],
  templateUrl: './business-search.component.html',
  styleUrl: './business-search.component.css'
})
export class BusinessSearchComponent implements OnInit {

  @ViewChild('dt') table!: Table;
  filterForm!: FormGroup;
  businessList: any[] = [];
  entityTypeList: any[] = [];
  industryList: any[] = [];
  agreementStatusList = [
      { value: 0, name: 'No Agreements' },            
      { value: 2, name: 'Completed' },
      { value: 3, name: 'Error' }     
    ];
  voucherStatusList = [
      { value: 0, name: 'No Vouchers' },
      { value: 1, name: 'Ready to Download' },      
      { value: 2, name: 'Expired' },
      { value: 3, name: 'Error' }          
    ];
  verificationStatusList = [
      { value: 0, name: 'Unverified' },
      { value: 1, name: 'Pending' },
      { value: 2, name: 'Approved' },
      { value: 3, name: 'Rejected' }      
    ];
  leadSourceList = [
      { value: 1, name: 'Wags' },
      { value: 2, name: 'PDP' },
      { value: 3, name: 'NSC' }      
    ];
  loading = false;
  modalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  filteredList: any[] = [];
  isIndustryOther = false;
  isEntityTypeOther = false;
  maxDate = new Date();
  selectedCompany: any;

  constructor(
    private fb: FormBuilder,
    private companyService: CompanyService,
    private headerService: HeaderService,    
    private ngx: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.buildForm();
    this.loadDropdowns();
    this.getBusinessList();
    this.filterForm.valueChanges.subscribe(values => {
    this.applyFilter(values);
  });

  }

   buildForm(): void {   

    this.filterForm = this.fb.group({
     
        companyName: ['',[           
            Validators.maxLength(100),
            Validators.pattern(ValidationPatterns.BUSINESS)
          ]
        ],       
        industry: [''],        
        entityType: [''],       
        noOfEmployessFrom: ['', Validators.pattern(ValidationPatterns.EMPLOYEES)],
        noOfEmployessTo: ['', Validators.pattern(ValidationPatterns.EMPLOYEES)],
        voucherStatus: [''], 
        createdDateFrom: [''],    
        createdDateTo: [''],      
        agreementStatus: [''], 
        verificationStatus: [''],
        leadSource: ['']
      }
      ,{ validators: numberRangeValidator, dateRangeValidator }
    );
  }

  loadDropdowns(): void {
    this.ngx.show()
    forkJoin({
      entityTypes: this.companyService.getAllEntityTypes(),
      industries: this.companyService.getAllIndustries()
    })
      .pipe(
        finalize(() => this.ngx.hide())
      )
      .subscribe({
        next: (res) => {
          this.entityTypeList = res.entityTypes;
          this.industryList = res.industries;
        },
        error: (err) => {
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.ErrorInAPICall;
          this.modalDlg = true;
        }
      });
  }

  getBusinessList(): void {
    this.ngx.show()
    forkJoin({
      businessList: this.companyService.getAllCompanies()
    })
      .pipe(
        finalize(() => this.ngx.hide())
      )
      .subscribe({
        next: (res) => {
          this.businessList = res.businessList;
          this.filteredList = res.businessList;
          let companyId = sessionStorage.getItem('companyId') || '';
           res.businessList.forEach(company => {
           if(companyId == company.companyId)
            {
              this.selectedCompany = company;
            }
          });         
        },
        error: (err) => {
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.ErrorInAPICall;
          this.modalDlg = true;
        }
      });
  }

  localDateToUtc(date: Date, endOfDay = false): Date {
  const localDate = new Date(date);

  localDate.setHours(
    endOfDay ? 23 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 999 : 0
  );

  return new Date(
    localDate.getTime() - localDate.getTimezoneOffset() * 60_000
  );
}

  applyFilter(filter: any) {   

    this.table.first = 0;
  this.filteredList = this.businessList.filter(item => {

    return (
      (!filter.companyName || item.companyName.toLowerCase().includes(filter.companyName.toLowerCase())) &&

      (!filter.industry || item.industry == filter.industry) &&

      (!filter.entityType || item.entityType == filter.entityType) &&

      (
        !filter.noOfEmployessFrom ||
        (
          filter.noOfEmployessTo
            ? (
                item.numberOfEmployees >= +filter.noOfEmployessFrom &&
                item.numberOfEmployees <= +filter.noOfEmployessTo
              )
            : item.numberOfEmployees == +filter.noOfEmployessFrom
        )
      ) &&

      (!filter.voucherStatus || item.voucherStatus === filter.voucherStatus) &&

      (!filter.createdDateFrom || new Date(item.createdAt + 'Z') >= this.localDateToUtc(filter.createdDateFrom, false)) &&

      (!filter.createdDateTo || new Date(item.createdAt + 'Z') <= this.localDateToUtc(filter.createdDateTo, true)) &&

      (!filter.agreementStatus || item.agreementStatus === filter.agreementStatus) &&

      (!filter.verificationStatus || item.verificationStatus === filter.verificationStatus) &&

      (!filter.leadSource || item.leadSource === filter.leadSource)
    );

  });}

  resetFilters() {
  this.filterForm.reset();
  this.filterForm.get('industry')?.setValue('');
  this.filterForm.get('entityType')?.setValue('');
  this.filterForm.get('voucherStatus')?.setValue('');
  this.filterForm.get('agreementStatus')?.setValue('');
  this.filterForm.get('verificationStatus')?.setValue('');
  this.filterForm.get('leadSource')?.setValue('');
}

  open(company: any): void {
    sessionStorage.setItem('companyId', company.companyId);
    sessionStorage.setItem('companyName', company.companyName);    
    this.headerService.setCompanyName(company.companyName);
    this.router.navigate(['/home']);
  }

  okClicked() {
    this.modalDlg = false;
  }

  formatZip(zip: string): string {
  const cleaned = zip.replace(/\D/g, ''); 
  return cleaned.length === 9
    ? `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`
    : cleaned;
  }

  onInput(event: any, controlName: string) {
  const input = event.target;

  // Keep digits only
  let value = input.value.replace(/\D/g, '');

  // Limit to 6 digits
  value = value.slice(0, 6);

  input.value = value;
  this.filterForm.get(controlName)?.setValue(value, { emitEvent: false });
}

}

export function numberRangeValidator(
  group: AbstractControl
): ValidationErrors | null {

  const fromControl = group.get('noOfEmployessFrom');
  const toControl = group.get('noOfEmployessTo');

  const from = fromControl?.value;
  const to = toControl?.value;

  if (
    from === null || to === null ||
    from === '' || to === ''
  ) {

    removeControlError(fromControl, 'numberRangeInvalid');
    removeControlError(toControl, 'numberRangeInvalid');

    return null;
  }

  const fromNum = Number(from);
  const toNum = Number(to);

  if (isNaN(fromNum) || isNaN(toNum)) {
    return null;
  }

  if (fromNum > toNum) {

    fromControl?.setErrors({
      ...fromControl.errors,
      numberRangeInvalid: true
    });

    toControl?.setErrors({
      ...toControl.errors,
      numberRangeInvalid: true
    });

    return { numberRangeInvalid: true };
  }

  removeControlError(fromControl, 'numberRangeInvalid');
  removeControlError(toControl, 'numberRangeInvalid');

  return null;
}

export function dateRangeValidator(
  group: AbstractControl
): ValidationErrors | null {

  const fromControl = group.get('createdDateFrom');
  const toControl = group.get('createdDateTo');

  if (!fromControl || !toControl) {
    return null;
  }

  const from = fromControl.value;
  const to = toControl.value;

  // Clear existing errors first
  removeControlError(fromControl, 'dateRangeInvalid');
  removeControlError(toControl, 'dateRangeInvalid');

  // Skip validation if either is empty
  if (!from || !to) {
    return null;
  }

  // Compare only yyyy-mm-dd strings
  const fromDate = new Date(from);
  const toDate = new Date(to);

  fromDate.setHours(0, 0, 0, 0);
  toDate.setHours(0, 0, 0, 0);

  if (fromDate > toDate) {

    fromControl.setErrors({
      ...fromControl.errors,
      dateRangeInvalid: true
    });

    toControl.setErrors({
      ...toControl.errors,
      dateRangeInvalid: true
    });

    return { dateRangeInvalid: true };
  }

  return null;
}

function removeControlError(control: any, errorKey: string): void {

  if (!control?.errors) return;

  const errors = { ...control.errors };

  delete errors[errorKey];

  control.setErrors(
    Object.keys(errors).length ? errors : null
  );
}
